import * as Sentry from '@sentry/browser';
import { remoteable } from 'store/next';
import { setErrorAction } from "./setErrorAction";



export const updateUserPaletteAction = (data): any => {
  return (dispatch, getState) => {
    const n = {
      type: 'UPDATE_USER_PALETTE',
      data,
    };

    dispatch(n);

    if (remoteable()) {
      const { theme, themeId } = getState();
      const nextTheme = {
        ...theme,
        userPalette: data,
      };

      window.client.themes
        .set(`/api/v2/themes/${themeId}`, nextTheme)
        .catch(err => {
          Sentry.withScope(scope => {
            scope.setExtra('message', err.err);
            Sentry.captureException(err);
          });
          dispatch(setErrorAction(err));
        });
    }
  };
};
